import { NGXAjax } from '../../common/Services/AjaxService.js';
import { resolve, reject } from './util/api-util';

function fetchSurveys() {
  return NGXAjax.get('/api/survey/list.json').then(resolve, reject);
}

export { fetchSurveys };
